import axios from 'axios'

const lsKeyMetaMask = 'web3token'

const BASE_URL = process.env.REACT_APP_API_URL || 'https://meta-dev.eastrelay.com/tornado/'

export const axiosInstance = axios.create({
  baseURL: BASE_URL,
  timeout: 180000,
})

axiosInstance.interceptors.request.use(
  (config) => {
    const authToken = localStorage.getItem(lsKeyMetaMask) || ''
    if (config.headers === undefined) {
      config.headers = {}
      config.headers['Web3'] = 'true'
    }
    if (authToken) {
      config.headers['Authorization'] = `${authToken}`
      config.headers['Web3'] = 'true'
    }

    return config
  },
  (error) => Promise.reject(error)
)
